import PollerRejection from '../../enums/PollerRejection';
import Status from '../../enums/Status';
import trackDeliveryOptionsShown from '../../tracking/DeliveryOptions/trackDeliveryOptionsShown';
import {deliveryOptionsPoller} from '../api/pollers/pollers';
import {TooltipAndOverlayIDs} from '../components/detailed-tooltip/TooltipLibrary';
import gtmPushDeliveryDataToCheckoutPage from '../google-tag-manager/gtmPushDeliveryDataToCheckoutPage';
import gtmPushFailureDeliveryDataToCheckoutPage from '../google-tag-manager/gtmPushFailureDeliveryDataToCheckoutPage';
import {getSelectedDeliveryData} from '../selectors/DeliveryAddressSelectors/DeliveryAddressSelectors';
import {isAnyDeliveryOptionTaxable} from '../selectors/DeliveryOptionsSelectors/DeliveryOptionsSelectors';
import getDeliveryOptionsDaysTrackingAttributes
from '../selectors/DeliveryOptionsSelectors/getDeliveryOptionsDaysTrackingAttributes';
import getAddressDefinitions from '../selectors/getAddressDefinitions';
import getDiscounts from '../selectors/OrderSummarySelectors/getDiscounts';
import {getSettings} from '../selectors/selectors';
import * as types from './action-types';
import handleDeliveryOptionFilteringByPostCodeForCollection
from './handleDeliveryOptionFilteringByPostCodeForCollection';
import {getOrderSummaryForDeliveryOption, updateOrderSummary} from './orderSummaryActions';
import {showOverlay} from './overlay-actions';

export function updateSelectedOptionIndex(groupId, selectedOptionIndex) {
  const selectedOption = {
    groupId,
    selectedOptionIndex,
  };
  
  return {type: types.UPDATE_SELECTED_OPTION_INDEX, selectedOption};
}

export function updateSelectedDeliverableDateIndex(groupId, optionIndex, selectedDeliverableDateIndex) {
  return {
    type: types.UPDATE_SELECTED_NAMED_DAY_INDEX, groupId, optionIndex, selectedDeliverableDateIndex,
  };
}

export function updateOptionalGroupUsed(groupId, used) {
  return {type: types.UPDATE_OPTIONAL_GROUP_USED, used, groupId};
}

export function openFastTrackInfoOverlay() {
  return dispatch => dispatch(showOverlay('fast_track_info'));
}

export function openResidentIdOverlay() {
  return dispatch => dispatch(showOverlay(TooltipAndOverlayIDs.RESIDENT_ID_DELIVERY_DESCRIPTION));
}

export function openDeliveryInformationOverlay() {
  return dispatch => dispatch(showOverlay(TooltipAndOverlayIDs.DELIVERY_INFORMATION));
}

export function updateOptionalGroupAndCallAPI(groupId, used) {
  return (dispatch) => {
    dispatch(updateOptionalGroupUsed(groupId, used));
    return dispatch(getOrderSummaryForDeliveryOption());
  };
}

export function updateSelectedOptionIndexAndCallAPI(groupId, selectedOptionIndex, mergedGroupIds) {
  return (dispatch) => {
    if (mergedGroupIds && mergedGroupIds?.length > 0) {
      mergedGroupIds.forEach((id) => {
        dispatch(updateSelectedOptionIndex(id, selectedOptionIndex));
      });
    } else {
      dispatch(updateSelectedOptionIndex(groupId, selectedOptionIndex));
    }
    
    return dispatch(getOrderSummaryForDeliveryOption());
  };
}

export function updateSelectedOptionIndexAndSelectedDeliverableDateIndex(groupId, selectedOptionIndex, selectedDeliverableDateIndex) {
  return (dispatch) => {
    dispatch(updateSelectedDeliverableDateIndex(groupId, selectedOptionIndex, selectedDeliverableDateIndex));
    return dispatch(updateSelectedOptionIndexAndCallAPI(groupId, selectedOptionIndex));
  };
}

export function updateFocusItem(focusItem) {
  return {type: types.UPDATE_FOCUS_ITEM, focusItem};
}

export function updateDeliveryOptions(deliveryOptions) {
  return {type: types.UPDATE_DELIVERY_OPTIONS, deliveryOptions};
}

export function resetDeliveryOptions() {
  return {type: types.RESET_DELIVERY_OPTIONS};
}

export function clearDeliveryOptions() {
  return (dispatch) => {
    dispatch(updateDeliveryOptions({deliveryGroups: []}));
  };
}

export function updateDeliveryOptionStatus(status) {
  return {type: types.UPDATE_DELIVERY_OPTION_STATUS, status};
}

export function populateNewAddressWithSelectedAddress() {
  return {type: types.POPULATE_NEW_ADDRESS_WITH_SELECTED_ADDRESS};
}

const handleSpecialOfferFiltering = (deliveryOptionData, getState) => {
  let hasFiltered = false;
  const specialOffer = getSettings(getState())?.special_offer_delivery || {offerId: undefined, deliveryId: undefined};
  
  const showSelectedCustomersDelivery = getSettings(getState())?.show_selected_customers_delivery;
  const customerOfferId = showSelectedCustomersDelivery?.offerId;
  const customerDeliveryId = showSelectedCustomersDelivery?.deliveryId;
  const discounts = getDiscounts(getState()) || [];
  const totalMatches = discounts.filter(discount => discount?.discountReference === customerOfferId).length;
  
  if (totalMatches === 0 && deliveryOptionData.deliveryGroups) {
    deliveryOptionData.deliveryGroups.forEach((deliveryGroup) => {
      if (deliveryGroup.deliveryOptions.some(item => item.id === customerDeliveryId)) {
        deliveryGroup.deliveryOptions
          .splice(deliveryGroup.deliveryOptions.findIndex(item => item.id === customerDeliveryId), 1);
        hasFiltered = true;
      }
    });
  }
  
  if (deliveryOptionData?.deliveryGroups?.length > 0
    && specialOffer.deliveryId
    && getDiscounts(getState())?.some(discount => discount.discountReference === specialOffer.offerId)) {
    deliveryOptionData.deliveryGroups.forEach((deliveryGroup) => {
      if (deliveryGroup?.deliveryOptions?.length > 1
        && deliveryGroup.deliveryOptions.some(item => item.id === specialOffer.deliveryId)) {
        deliveryGroup.deliveryOptions
          .splice(deliveryGroup.deliveryOptions.findIndex(item => item.id === specialOffer.deliveryId), 1);
        hasFiltered = true;
      }
    });
  }
  
  return {deliveryOptionData, hasFiltered};
};

export function handleDeliveryOptionRequestSuccess(response) {
  return (dispatch, getState) => {
    let hasEcoDelivery = false;
    
    const filterDeliveryOptionByPostcodeForCollectionType = !!getSettings(getState())?.filter_delivery_option_by_postcode_for_collection_type;
    
    let deliveryOptionData = response.body;
    let hasFiltered;
    
    if (!filterDeliveryOptionByPostcodeForCollectionType) {
      const result = handleSpecialOfferFiltering(response.body, getState);
      deliveryOptionData = result?.deliveryOptionData;
      hasFiltered = result?.hasFiltered;
    } else {
      const result = handleDeliveryOptionFilteringByPostCodeForCollection(deliveryOptionData, getState);
      deliveryOptionData = result?.deliveryOptionData;
      hasFiltered = result?.hasFiltered;
    }
    
    if (getSettings(getState())?.homebase_analytics_enabled) {
      gtmPushDeliveryDataToCheckoutPage(deliveryOptionData, getState);
    }
    
    if (deliveryOptionData?.deliveryGroups?.length > 0) {
      const deliveryGroupsCopy = deliveryOptionData.deliveryGroups;
      for (let i = 0; i < deliveryOptionData.deliveryGroups.length; i += 1) {
        const deliveryGroup = deliveryOptionData.deliveryGroups[i];
        if (deliveryGroup?.deliveryOptions?.length > 1) {
          const selectedDeliveryOptionIndex = deliveryGroup.selectedOptionIndex;
          const selectedDeliveryOption = deliveryGroup.deliveryOptions[selectedDeliveryOptionIndex];
          if (!hasEcoDelivery && deliveryGroup.deliveryOptions.some(item => item.id === 57)) {
            hasEcoDelivery = true;
          }
          const indexPos = deliveryGroup.deliveryOptions.findIndex(item => item.id === 57);
          const ecoDelivery = deliveryGroup.deliveryOptions.splice(indexPos, 1);
          deliveryGroup.deliveryOptions.push(ecoDelivery[0]);
          if (hasEcoDelivery) {
            deliveryGroupsCopy[i].selectedOptionIndex = deliveryGroup.deliveryOptions.findIndex(item => item.id === selectedDeliveryOption.id);
          }
        }
      }
      
      if (hasEcoDelivery) {
        deliveryOptionData.deliveryGroups = deliveryGroupsCopy;
      }
    }
    
    dispatch(updateDeliveryOptionStatus('success'));
    dispatch(updateDeliveryOptions(deliveryOptionData));
    
    trackDeliveryOptionsShown(deliveryOptionData, isAnyDeliveryOptionTaxable(getState()),
      getDeliveryOptionsDaysTrackingAttributes(getState()));
    
    if (deliveryOptionData.orderSummary && !hasEcoDelivery && !hasFiltered) {
      dispatch(updateOrderSummary(deliveryOptionData.orderSummary));
    } else {
      dispatch(getOrderSummaryForDeliveryOption());
    }
  };
}

export function handleDeliveryOptionRequestFailure(response) {
  return (dispatch, getState) => {
    const status = (response.reason && response.reason === PollerRejection.NETWORK) ? Status.NETWORK_ERROR : 'error';
    if (getSettings(getState())?.homebase_analytics_enabled) {
      gtmPushFailureDeliveryDataToCheckoutPage(getState);
    }
    dispatch(updateDeliveryOptionStatus(status));
  };
}

export function setDeliveryCountryUsedForDeliveryOptions(country) {
  return {
    type: types.UPDATE_DELIVERY_COUNTRY,
    country,
  };
}

export function getDeliveryOptions() {
  return (dispatch, getState) => {
    const addressDefinitions = getAddressDefinitions(getState());
    const addressData = getSelectedDeliveryData(getState(), addressDefinitions);
    if (addressData) {
      dispatch(updateDeliveryOptionStatus('loading'));
      dispatch(clearDeliveryOptions());
      dispatch(setDeliveryCountryUsedForDeliveryOptions(addressData.country));
      return deliveryOptionsPoller.execute(addressData)
        .then(successResponse => dispatch(handleDeliveryOptionRequestSuccess(successResponse)))
        .catch(failureResponse => dispatch(handleDeliveryOptionRequestFailure(failureResponse)));
    }
  };
}
